import { render, staticRenderFns } from "./document-info-quotation.vue?vue&type=template&id=3620e9da"
import script from "./document-info-quotation.vue?vue&type=script&lang=js"
export * from "./document-info-quotation.vue?vue&type=script&lang=js"
import style0 from "./document-info-quotation.vue?vue&type=style&index=0&id=3620e9da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports